import { getAppTitle } from '@/scripts/root/appTitle'

export type LegalDocumentContent = Record<string, Record<string, string>>

const localizeAppName = (
  content: LegalDocumentContent
): LegalDocumentContent => {
  const appTitle = getAppTitle()

  return Object.fromEntries(
    Object.entries(content).map(([sectionTitle, section]) => [
      sectionTitle,
      Object.fromEntries(
        Object.entries(section).map(([title, value]) => [
          title,
          value.split('AI Workout Log').join(appTitle),
        ])
      ),
    ])
  )
}

export function loadPrivacyPolicyContent(
  language: string
): LegalDocumentContent {
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    return localizeAppName(require(`@/data/privacyPolicy/${language}.json`))
  } catch {
    // Legal translations may be added separately; never leave the page blank.
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    return localizeAppName(require('@/data/privacyPolicy/en.json'))
  }
}

export function loadTermsOfUseContent(language: string): LegalDocumentContent {
  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    return localizeAppName(require(`@/data/termsOfUse/${language}.json`))
  } catch {
    // Legal translations may be added separately; never leave the page blank.
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    return localizeAppName(require('@/data/termsOfUse/en.json'))
  }
}
